export default "__VITE_ASSET__CM_pnoH3__"